import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { DateDropdown } from "../../../components/DateDropdown/DateDropdown";
import { DEPRECATED_TextInput } from "../../../components/DEPRECATED_TextInput";
import { FormField } from "../../../components/Form/FormField";
import { Info } from "../../../components/Info/Info";
import { Txt } from "../../../components/Txt/Txt";
import { useTranslations } from "../../../providers/useTranslations";
import styles from "./FieldsArray.module.scss";
export const FieldsArray = memo(({ fieldName = (name) => name, ...method }) => {
    const { __ } = useTranslations();
    const renderOptionalInfo = () => {
        if (method.isOptional) {
            return (_jsx(Info, { className: styles.optionalInfoIcon, variant: "info", message: __("auth.registration.age_verification.optional_message") }));
        }
        return null;
    };
    return (_jsx("div", { className: styles.formField, children: method.fields.map((item) => {
            const ageVerificationLabel = __(`age_verification.form.${item.code}.label`, [], item.label);
            if (item.type === "date") {
                return (_jsx("div", { children: _jsxs("div", { className: styles.dobBlock, children: [_jsxs(Txt, { className: styles.infoSupp, children: [ageVerificationLabel, " ", item.is_required ? "*" : ""] }), _jsx(DateDropdown, { fieldName: `avpValues.${item.code}`, dropdownFieldPrefix: item.code })] }) }, item.code));
            }
            return (_jsxs("div", { children: [_jsx(FormField, { name: fieldName(item.code), label: ageVerificationLabel, render: ({ field }) => (_jsx(DEPRECATED_TextInput, { ...field, dataTestId: item.code, placeholder: __(`age_verification.form.${item.code}.hint`, [], item.hint), className: styles.limitMaxWidth })), validation: {
                            required: {
                                value: item.is_required && !method.isOptional,
                                message: __(`auth.age_verification.method_fields.${item.code}.validation.field_required`, undefined, __("validation.field_required")),
                            },
                            ...(item.validation && {
                                pattern: {
                                    value: new RegExp(item.validation),
                                    message: __("ageconfirmation.pattern.error"),
                                },
                            }),
                        }, defaultValue: "" }, item.code), renderOptionalInfo()] }, item.code));
        }) }));
});
//# sourceMappingURL=FieldsArray.js.map